import { Prop, Component, h } from "@stencil/core";
import classNames from "classnames";
import { ListProps } from "./f-list-model";

@Component({
  tag: "f-list",
  styleUrl: "f-list.scss",
  shadow: false,
})

// It's not possible to nest one f-list component inside another
// (causes invalid html and moves list elements out of the web component while page is being rendered by the browser, before javascript runs)
// Lists can only be nested by using one f-list component and inside using the html tags with valid classes.
export class List {
  @Prop() type: ListProps["type"] = "ul";
  @Prop() variant: ListProps["variant"];

  render() {
    const CustomTag = this.type;
    const listVariant = this.variant || (this.type === "ul" ? "dot" : "num");
    const listClass = classNames("a-list", {
      [`a-list--${listVariant}`]: listVariant,
    });

    return (
      <CustomTag class={listClass} data-test="list">
        <slot />
      </CustomTag>
    );
  }
}
